<template>
  <Navbarv2 :informasiDasar="informasiDasar" />
  <!-- MOBILE VIEW -->
  <div class="flex lg:hidden">
    <div class="grid ml-10">
      <!-- JUDUL -->
      <h1 class="font-semibold underline underline-offset-8 text-4xl text-blue-maluku -mt-36">
        {{ $t("message.simpanan") }}
      </h1>
      <div class="flex ">
        <router-link class="text-sm" to="/bisnis">{{ $t("message.bisnis") }}</router-link>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          class="pt-1 w-4 h-4">
          <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
        </svg>
        <router-link class="text-sm" to="/bisnis">{{ $t("message.simpanan") }}</router-link>
      </div>
    </div>
  </div>
  <!-- H1 -->
  <div v-if="grouped.length > 0" class="grid md:ml-32 md:mr-32 md:mt-20 mt-10 mr-10 ml-10">
    <div class="grid grid-cols-12 content-center">
      <div class=" md:col-span-3 col-span-12">
        <!-- SIDEBAR -->
        <div class="z-0 hidden lg:flex absolute scale-75 -ml-60 -mt-16">
          <img src="@/assets/icon/circle-rotate.svg" alt="">
        </div>
        <div class="grid font-sans">
          <div class="z-0 flex rounded-lg h-auto md:w-60 py-5 bg-white text-ungu shadow-tabungan">
            <div class="grid pl-8 justify-items-start">
              <!-- Judul -->
              <div class="z-10 relative">
                <h1 class="font-semibold text-2xl text-blue-maluku">
                  {{ $t("message.simpanan") }}
                </h1>
              </div>
              <div v-for="item in grouped" :key="item.id">
                <p class="pt-4 font-semibold text-ungu">{{ $i18n.locale == 'id' ? item.jenis : item.jenis_en }}</p>
                <ul v-if="item.children.length > 0" class="list-nostyle space-y-0 mt-2">
                  <li v-for="sub in item.children" :key="sub.id" class="duration-200 ease-in-out"
                    @click="changeMenu(sub.id)"
                    :class="section === sub.id ? 'p-2 w-44 bg-birulangitmaluku rounded-lg text-blue-maluku font-semibold cursor-pointer' : 'p-2 text-biru cursor-pointer'">
                    {{ $i18n.locale == 'id' ? sub.nama : sub.nama_en }}</li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="md:col-span-9 col-span-12 md:mt-0 mt-10">
        <!-- ISI ARTIKEL -->
        <div>
          <Transition v-for="child in children" :key="child.id" name="menu" tag="div">
            <Tabunganmutiara v-if="child.id === section" :item="child" />
          </Transition>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="w-full relative">
      <Empty />
    </div>
  </div>
  <div class="z-10 relative">
    <Footer :informasiDasar="informasiDasar" />
  </div>

</template>

<script>
import Tabunganmutiara from "./Tabunganmutiara.vue"
import Navbar from "../../Navbar.vue";
import Navbarv2 from "../../Navbarv2.vue";
import Footer from "../../Footer.vue";
import TabunganSimpeda from "../tabungan/TabunganSimpeda.vue";
import Tabunganku from "../tabungan/Tabunganku.vue";
import TabunganSimpel from "../tabungan/TabunganSimpel.vue";
import Deposito from "../tabungan/Deposito.vue";
import Giro from "../tabungan/Giro.vue";
import SidebarMenu from "./SidebarMenu.vue";
import { computed, ref } from "@vue/reactivity";
import { getProdukByJenis, getIsiProdukById, getInformasiDasar } from "@/api/LandingPageApi";
import { onMounted } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import Empty from "@/views/landingpage/Empty.vue"

export default {
  components: {
    Tabunganmutiara,
    Navbar,
    Footer,
    TabunganSimpeda,
    Tabunganku,
    TabunganSimpel,
    Deposito,
    Giro,
    SidebarMenu,
    Empty,
    Navbarv2
  },
  setup() {
    const section = ref("");
    const changeMenu = (id) => {
      if (section.value !== id) section.value = id;
    };

    const load = ref(false);
    const informasiDasar = ref({});
    const items = ref([]);
    const parents = ref([])
    const children = ref([])
    const route = useRoute();
    onMounted(async () => {
      load.value = true;
      await getInformasi();
      await getProduk();
      load.value = false;
    });

    const getInformasi = async () => {
      const result = await getInformasiDasar();
      if (result?.data?.data) informasiDasar.value = result.data.data;
    };

    const getProduk = async () => {
      const result = await getProdukByJenis("Simpanan");
      if (result?.data?.data) {
        parents.value = result.data.data;
        await result.data.data.forEach(async (element) => {
          await getJenisProduk(element.id)
        });
      }
    };

    const grouped = computed(() => {
      section.value = children.value[0]?.id
      return parents.value.map(parent => {
        return { ...parent, children: [] };
      }).reduce((acc, parent) => {
        children.value.forEach(child => {
          if (child.id_jenis_simpanan === parent.id) {
            parent.children.push(child);
          }
        });
        acc.push(parent);
        return acc;
      }, []);
    })


    const getJenisProduk = async (jenis) => {
      const result = await getIsiProdukById(jenis);
      if (result?.data?.data) {
        result.data.data.forEach(Element => {
          children.value.push(Element)
        })
      }
    };

    return { section, changeMenu, grouped, children, informasiDasar };
  },
};
</script>

<style scoped>
:deep() .menu-enter-active {
  transition: all 0.2s ease;
  transition-delay: 300ms;
}

:deep() .menu-leave-active {
  transition: all 0.2s ease;
  ;
}

:deep().menu-enter-from,
.menu-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>